import { render, staticRenderFns } from "./RelatedUsersForm.vue?vue&type=template&id=15ce1825&scoped=true&"
import script from "./RelatedUsersForm.vue?vue&type=script&lang=js&"
export * from "./RelatedUsersForm.vue?vue&type=script&lang=js&"
import style0 from "./RelatedUsersForm.vue?vue&type=style&index=0&id=15ce1825&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce1825",
  null
  
)

export default component.exports